(function() {
    var $launchQuizBtn = $(".begin_quiz"),
        $body = $('body'),
        customerLoggedIn = $body.hasClass('customer-logged-in');

    $launchQuizBtn.on('click', function() {
        if ($launchQuizBtn.length !== 0 && customerLoggedIn) {
            window.location.href = "https://www.reneerouleau.com/apps/proxy/quizzes/2/questions/26";
        } else {
            window.location.href = "https://www.reneerouleau.com/pages/quiz-confirmation";
        }
    });
})();
